"use client";

import BaseModal from "./BaseModal";
import { useModal } from "./ModalProvider";
import CustomerLoginForm from "@/components/auth/CustomerLoginForm";
import { clearAuthIntent, clearCheckoutIntentPending } from "@/lib/auth/authIntent";

function isCheckoutRedirectPath(path) {
  return typeof path === "string" && (path === "/checkout" || path.startsWith("/checkout?"));
}

export default function CustomerLoginModal({
  onClose,
  next: nextFromModalProps = null,
  initialEmail = "",
  context = null,
  lockEmail = false,
  onSuccess = null,
  onCancel = null,
}) {
  const { openModal } = useModal();
  const isStaffInviteContext = context === "staff-invite";
  if (process.env.NODE_ENV !== "production") {
    console.info("[auth-next] modal received next:", nextFromModalProps || "/");
  }
  const handleClose = ({ canceled = true } = {}) => {
    clearAuthIntent();
    if (canceled) clearCheckoutIntentPending();
    if (canceled) onCancel?.();
    onClose?.();
  };

  return (
    <BaseModal
      title={isStaffInviteContext ? "Sign in to accept invite" : "Welcome back"}
      description={
        isStaffInviteContext
          ? "Sign in with the invited email to continue accepting this staff invite."
          : "Sign in to your customer account to continue exploring nearby businesses."
      }
      onClose={() => handleClose()}
      compactScrollable
    >
      <CustomerLoginForm
        next={nextFromModalProps}
        initialEmail={initialEmail}
        context={context}
        onSuccess={async (destination, meta) => {
          if (!isCheckoutRedirectPath(destination)) {
            handleClose({ canceled: false });
          }
          await onSuccess?.(destination, meta);
        }}
        onSwitchToSignup={() =>
          openModal("customer-signup", {
            ...(nextFromModalProps ? { next: nextFromModalProps } : {}),
            ...(initialEmail ? { initialEmail } : {}),
            ...(context ? { context } : {}),
            ...(lockEmail ? { lockEmail } : {}),
          })
        }
      />
    </BaseModal>
  );
}
